import { handleActions } from 'redux-actions';
import reducersUtils from 'state/utils';
import { removeKeys } from 'utils/object';
import actions from 'state/errors/actionCreators';
import initialState from 'state/errors/initial.state';

const errorsReducer = handleActions(
  {
    [reducersUtils.RESET_ORDER_STATE]: () => initialState,
    [actions.setError]: (state, { payload: { errors } }) => ({
      ...state,
      ...errors,
    }),
    [actions.removeError]: (state, { payload: { errors } }) => ({
      ...removeKeys(errors, state),
    }),
    [actions.cleanErrors]: () => initialState,
  },
  initialState
);

export default errorsReducer;
